export const ZhChtVideoStrings = {
  NO_ACTIVE_STREAMS: "沒有直播"
}